import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type NoViewpointBubbleFieldsArgs = {
  onChangeSelectedFields: OnButtonClick;
  i18nLocale: I18nLocale;
};

export const noViewpointBubbleFields = ({
  onChangeSelectedFields,
  i18nLocale,
}: NoViewpointBubbleFieldsArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noViewpointBubbleFields.title',
    'No value in the Bubble Chart fields'
  ),
  description: (
    <>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFields.description1',
        'The dataset has no value in the bubble size, X or Y-axis fields.'
      )}
      <br />
      <br />
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFields.description2',
        'Change the selected Bubble Chart fields or add values to the fields.'
      )}
    </>
  ),
  children: (
    <PrimaryButton onClick={onChangeSelectedFields}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFields.changeSelectedFields',
        'Change selected fields'
      )}
    </PrimaryButton>
  ),
});
